import React from 'react';
import KeywordRuleDetailSection from '../../../sections/AdminDashboard/Configuration/KeywordRuleDetail';

const KeywordRuleDetail = () => {
  return <KeywordRuleDetailSection />;
};

export default KeywordRuleDetail;
